import TimedOut from "./TimedOut";

export default TimedOut;

